import api from "./axios"
import { ENDPOINT_DEV } from './configs';

export const getPortalsByOrg = async (orgId: string) => {
    return await api.get(ENDPOINT_DEV + 'organization/' + orgId + '/portal').then((res) => {
        return res;
    });
};
